import React, { useEffect, useRef, useState } from 'react';
import Text from '../components/elements/TextComponent';
import InputField from '../components/elements/InputField';
import TextWithButton from '../components/elements/TextWithButtonComponent';
import Button from '../components/elements/Button';
import userAtDesk from '../assets/userAtDesk.svg';
import ImageComponent from '../components/elements/ImageComponent';
import { registerUser } from '../api/userApi';
import { useNavigate } from 'react-router-dom';
import { isStrongPassword } from '../utils/utilFunctions';

const PURPLE_HEIGHT = 240;

const MobileRegister: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [imageSize, setImageSize] = useState(160);
  const whiteSectionRef = useRef<HTMLDivElement>(null);
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
      const update = () => {
        const vh = window.visualViewport?.height || window.innerHeight;
        const keyboardHeight = window.innerHeight - vh;
  
        setKeyboardOpen(keyboardHeight > 100);
  
        const w = window.innerWidth;
        const size = Math.min(w * 0.45, vh * 0.3);
        setImageSize(Math.max(140, Math.min(size, 220)));
      };
  
      update();
      window.visualViewport?.addEventListener('resize', update);
      window.addEventListener('resize', update);
      return () => {
        window.visualViewport?.removeEventListener('resize', update);
        window.removeEventListener('resize', update);
      };
    }, []);
    
  const handleRegister = async () => {
    if (!agreed) {
      setStatus('error');
      setMessage('You must agree to the Terms and Privacy Policy');
      return;
    }
    const passwordResult = isStrongPassword(password);
    if (!passwordResult.valid) {
      setStatus('error');
      setMessage(passwordResult?.message !== undefined ? passwordResult?.message : 'Password must be at least 8 characters long.'); // or display result.message to the user
      return;
    }
    const result = await registerUser({ email, password });
    if (result.error) {
      setStatus('error');
      setMessage('Failed to register new user check if email is spelled correctly');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div
      style={{
        height: '100vh',
        fontFamily: 'Montserrat',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* 🟪 Top Purple Section */}
      <div
        style={{
          height: PURPLE_HEIGHT,
          backgroundColor: 'var(--primary)',
          padding: '24px 16px',
          display: keyboardOpen ? 'none' : 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        <ImageComponent
          src={userAtDesk}
          center
          style={{
            width: `${imageSize}px`,
            height: `${imageSize}px`,
            objectFit: 'contain',
          }}
        />
        <div>
          <Text
            text="ComeChatWithMe.ai"
            fontSize="24px"
            fontWeight="700"
            color="#ffffff"
            textAlign="center"
            navigateToHome
          />
          <Text
            text="Register"
            fontSize="14px"
            fontWeight="400"
            color="#ffffff"
            textAlign="center"
          />
        </div>
      </div>

        {/* ⚪ Scrollable White Section */}
      <div
        ref={whiteSectionRef}
        style={{
          flex: 1,
          backgroundColor: '#ffffff',
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          overflowY: 'auto',
          padding: '24px 20px 160px',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <Text text="Register" fontSize="24px" fontWeight="700" color="#030303" textAlign="left" />

        <div style={{ marginTop: 12 }}>
          <TextWithButton
            text="Registor or "
            fontSize="14px"
            fontWeight="400"
            color="#030303"
            textAlign="left"
            showButton
            buttonLabel="login"
            onButtonClick={() => navigate('/login')}
          />
        </div>

        <div style={{ marginTop: 20 }}>
          <InputField
            text="Enter your email"
            fontSize="16px"
            fontWeight={500}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div style={{ marginTop: 20 }}>
          <Text
            text="Password"
            fontSize="16px"
            fontWeight="400"
            color="#030303"
            textAlign="left"
          />
        </div>

        <InputField
          text=""
          fontSize="16px"
          fontWeight={500}
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />

            {/* Terms and Privacy links */}
            <div
                style={{
                    marginTop: 8,
                    marginBottom: 20,
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    fontFamily: 'Montserrat',
                    fontSize: '14px',
                    lineHeight: '18px',
                    color: '#030303',
                }}
                >
                <input
                    type="checkbox"
                    checked={agreed}
                    onChange={() => setAgreed((prev) => !prev)}
                    style={{ marginRight: 8 }}
                />
                <span>I agree to the&nbsp;</span>
                <a
                    href="/termsofservice"
                    style={{
                    color: 'var(--primary)',
                    textDecoration: 'underline',
                    marginRight: 4,
                    }}
                >
                    Terms of Service
                </a>
                <span>and&nbsp;</span>
                <a
                    href="/privacypolicy"
                    style={{
                    color: 'var(--primary)',
                    textDecoration: 'underline',
                    }}
                >
                    Privacy Policy
                </a>
                </div>


            <div className="margin-top-30 margin-bottom-20">
              <Button
                backgroundColor="var(--primary)"
                color="#ffffff"
                label="Register"
                onClick={handleRegister}
                disabled={!agreed}
              />
            </div>
            {status !== 'idle' && (
            <p
                style={{
                fontFamily: 'Montserrat',
                fontSize: '14px',
                marginTop: '20px',
                color: status === 'success' ? '#2e7d32' : '#d32f2f',
                textAlign: 'left',
                }}
            >
                {message}
            </p>
            )}
   
        </div>
      </div>
  
  );
};

export default MobileRegister;
